import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Content } from '@shared/layouts'
import { ActionMenu } from 'domains/Showcases/Collections/AccessKeys/AccessKey'
import { useCollectionAccessKeyUpdateMutation } from 'hooks/mutations/showcase'
import { configRoute } from 'pages/NWPlatform/Collections/Collection/AccessKey/Routing'
import { collectionQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { t } = useTranslation(['pages', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { collectionId, accessKeyId } = configRoute.useParams()

  const collectionAccessKeyQuery = useQuery(collectionQueryKeys.accessKeyDetail({ collectionId, keyId: accessKeyId }))
  const { data: accessKey } = collectionAccessKeyQuery

  const { mutate: updateAccessKey, ...accessKeyUpdateMutation } = useCollectionAccessKeyUpdateMutation()

  const handleUpdateAccessKeyName = useCallback(
    (title: string, closeCallback: () => void) => {
      if (accessKey) {
        updateAccessKey(
          {
            keyId: accessKeyId,
            collectionId,
            showcaseCollectionAccessKeyEdit: {
              name: title,
            },
          },
          { onError: () => enqueueSnackbar(t('pages:Showcase.updateError')), onSettled: closeCallback },
        )
      }
    },
    [t, accessKey, updateAccessKey, accessKeyId, collectionId, enqueueSnackbar],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={collectionAccessKeyQuery.data?.name ?? ''}
          isLoading={collectionAccessKeyQuery.isLoading}
          isSaving={accessKeyUpdateMutation.isPending}
          onSave={handleUpdateAccessKeyName}
          Actions={<ActionMenu />}
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
